import modal from './modal.js';

const chat = {
    _bindInsideAvailability: function() {
        if (typeof window.insideFrontInterface == 'undefined') {
            setTimeout(this._bindInsideAvailability.bind(this), 1000);
            return;
        }
        window._insideGraph.bind('chatavailable', this._onChatAvailable.bind(this));
    },
    _onChatAvailable: function(available) {
        this._chatLoaded = true;
        this._chatAvailable = available;

        if (available && this._chatRequested) {
            if (this._modal) {
                this._modal.close();
            }

            window.insideFrontInterface.openChatPane();
        }

        this._chatRequested = false;
    },
    launchChatWindow: function() {
        if (this._chatAvailable) {
            window.insideFrontInterface.openChatPane();
        } else {
            if (!this._chatLoaded) {
                this._chatRequested = true;
            }

            const div = document.createElement('div');

            div.innerHTML =
                "Thanks for reaching out to SmartPak! We're not available to chat right now, so please call us at <span class='hideOnMobile'>1-800-461-8898</span><span class='showOnMobile'><a href='tel:1-800-461-8898'>1-800-461-8898</a></span> for immediate assistance.  Have a great ride!";

            this._modal = modal(div, {
                title: 'Chat',
                removeContents: true
            });
        }
    },
    init: function() {
        this._modal = null;
        this._chatLoaded = false;
        this._chatRequested = false;
        this._chatAvailable = false;

        this._bindInsideAvailability();

        document.addEventListener('click', e => {
            if (e.target.classList.contains('chatZone')) {
                e.preventDefault();
                this.launchChatWindow();
            }
        });
    }
};

export default chat;
